export const tableschema2 = {
    "name_table": "Розділ II. Наявність дітей і місць у групах на кінець звітного року",
    "titles": [
        "Усього у тому числі за видами груп",
        "групи загального розвитку",
        "спеціальні групи",
        "у тому числі для дітей",
        "з функціональними сенсорними труднощами",
        "з них передбачають обмеження",
        "зорової функції",
        "з функціональними фізичними або моторними труднощами",
        "з функціональними мовленнєвими труднощами",
        "із складними порушеннями розвитку",
        "із соціоадаптаційними (соціокультурними) труднощами",
        "інклюзивні групи",
        "групи короткотривалого перебування",
        "групи з цілодобовим перебуванням дітей"
    ],
    "parts": [
        {
            "title": "Кількість дітей, осіб",
            "subtitle": "усього",
            "fields": [
                "GRchild2001",
                "GRchild21",
                "GRchild2201",
                "GRchild2241",
                "GRchild51",
                "GRchild2211",
                "GRchild2231",
                "GRchild2251",
                "GRchild2221",
                "GRchild101",
                "GRchild2261",
                "GRchild2301",
                "GRchild2401",
                "GRchild2501"
            ]
        },
        {
            "title": "Кількість дітей, осіб",
            "subtitle": "3 роки і старше",
            "fields": [
                "GRchild2002",
                "GRchild22",
                "GRchild2202",
                "GRchild2242",
                "GRchild52",
                "GRchild2212",
                "GRchild2232",
                "GRchild2252",
                "GRchild2222",
                "GRchild102",
                "GRchild2262",
                "GRchild2302",
                "GRchild2402",
                "GRchild2502"
            ]
        },
        {
            "title": "Кількість груп, од",
            "subtitle": "усього",
            "fields": [
                "GRchild2003",
                "GRchild23",
                "GRchild2203",
                "GRchild2243",
                "GRchild53",
                "GRchild2213",
                "GRchild2233",
                "GRchild2253",
                "GRchild2223",
                "GRchild103",
                "GRchild2263",
                "GRchild2303",
                "GRchild2403",
                "GRchild2503"
            ]
        },
        {
            "title": "Кількість груп, од",
            "subtitle": "3 роки і старше",
            "fields": [
                "GRchild2004",
                "GRchild24",
                "GRchild2204",
                "GRchild2244",
                "GRchild54",
                "GRchild2214",
                "GRchild2234",
                "GRchild2254",
                "GRchild2224",
                "GRchild104",
                "GRchild2264",
                "GRchild2304",
                "GRchild2404",
                "GRchild2504"
            ]
        },
        {
            "title": "Кількість місць, од",
            "subtitle": "усього",
            "fields": [
                "GRchild2005",
                "GRchild25",
                "GRchild2205",
                "GRchild2245",
                "GRchild55",
                "GRchild2215",
                "GRchild2235",
                "GRchild2255",
                "GRchild2225",
                "GRchild105",
                "GRchild2265",
                "GRchild2305",
                "GRchild2405",
                "GRchild2505"
            ]
        },
        {
            "title": "Кількість місць, од",
            "subtitle": "3 роки і старше",
            "fields": [
                "GRchild2006",
                "GRchild26",
                "GRchild2206",
                "GRchild2246",
                "GRchild56",
                "GRchild2216",
                "GRchild2236",
                "GRchild2256",
                "GRchild2226",
                "GRchild106",
                "GRchild2266",
                "GRchild2306",
                "GRchild2406",
                "GRchild2506"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14"
        ],
        "parts": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6"
        ]
    }
};